module.exports = __webpack_public_path__ + "img/protection_skincover_white.70967489.jpg";